export const getCollectionDetail = '/sku/sku-by-collection-id';
export const deleteCollectionDetail = '/collections/delete-product-by-id/';
export const getNewCollectionDetail = '/sku';
export const addNewCollectionDetailProduct = '/collections/add-product-by-ids';
